import { Component, inject, Input, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { finalize } from 'rxjs';
import { Router } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { RoomService } from '@service/room.service';
import { addIcons } from 'ionicons';
import { closeOutline } from 'ionicons/icons';
import { TranslocoPipe } from '@ngneat/transloco';
import { StorageService } from '@service/storage.service';

@UntilDestroy()
@Component({
  selector: 'app-exit-room-dialog',
  standalone: true,
  imports: [
    IonicModule,
    TranslocoPipe
  ],
  templateUrl: './exit-room-dialog.component.html',
  styleUrl: './exit-room-dialog.component.scss'
})
export class ExitRoomDialogComponent implements OnInit {
  @Input() closeModal: (result?: any) => void;
  @Input() data: any;
  pending = false;
  commonError = null;
  roomId = null;

  private readonly _roomService = inject(RoomService);
  private readonly _router = inject(Router);
  private readonly _storageService = inject(StorageService);

  constructor() {
    addIcons({ closeOutline });
  }

  ngOnInit(): void {
    if (this.data.roomId) {
      this.roomId = this.data.roomId;
    }
  }

  exitRoom(): void {
    this.pending = true;
    this._roomService.exitRoom(this.roomId)
      .pipe(untilDestroyed(this), finalize(() => this.pending = false))
      .subscribe({
        next: (res) => {
          this._storageService.clearRoomId();
          this.closeModal(true);
        }, error: err => {
          this.commonError = err;
        }
      });
  }
}
